import { createBrowserRouter } from 'react-router';
import Opening from '../components/Opening';
import { onboardingLoader } from '../loaders/onboardingLoader';
import { rootLoader } from '../loaders/rootLoader';
import { verifyLoader } from '../loaders/verifyLoader';
import { welcomeLoader } from '../loaders/welcomeLoader';
import Dashboard from '../pages/dashboard';
import Onboarding from '../pages/onboarding';
import Profile from '../pages/profile';
import RootLayout from '../pages/rootLayout';
import RouteError from '../pages/routeError';
import SignedOut from '../pages/signedOut';
import Soon from '../pages/soon';
import Verify from '../pages/verify';
import Welcome from '../pages/welcome';

/**
 * Routes that take a session (`/verify`, `/auth/callback`) sit outside the root
 * layout — its loader would bounce them to /signed-out before they ever got the
 * chance to establish one.
 *
 * `/onboarding` is outside it for the mirror-image reason: rootLoader sends
 * anyone unfinished there, so putting it under that loader would loop.
 *
 * `/welcome` is outside it too: it is where induction ends, full-bleed, once.
 */
export const router = createBrowserRouter([
  {
    path: '/verify',
    element: <Verify />,
    loader: verifyLoader,
    hydrateFallbackElement: <Opening />,
    errorElement: <RouteError />
  },
  {
    // The path apps/web uses. Same loader, so links minted either side work.
    path: '/auth/callback',
    element: <Verify />,
    loader: verifyLoader,
    hydrateFallbackElement: <Opening />,
    errorElement: <RouteError />
  },
  {
    path: '/signed-out',
    element: <SignedOut />,
    errorElement: <RouteError />
  },
  {
    path: '/onboarding',
    element: <Onboarding />,
    loader: onboardingLoader,
    hydrateFallbackElement: <Opening />,
    errorElement: <RouteError />
  },
  {
    path: '/welcome',
    element: <Welcome />,
    loader: welcomeLoader,
    hydrateFallbackElement: <Opening />,
    errorElement: <RouteError />
  },
  {
    id: 'root',
    path: '/',
    element: <RootLayout />,
    loader: rootLoader,
    hydrateFallbackElement: <Opening />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'profile', element: <Profile /> },
      { path: 'academy', element: <Soon /> },
      { path: 'projects', element: <Soon /> },
      { path: 'portfolio', element: <Soon /> },
      { path: 'find-projects', element: <Soon /> },
      { path: 'find-talent', element: <Soon /> },
      { path: 'requirements', element: <Soon /> }
    ]
  }
]);
